import { render } from "./StudentAttendanceDialog.vue?vue&type=template&id=0f81bb57&scoped=true"
import script from "./StudentAttendanceDialog.vue?vue&type=script&lang=js"
export * from "./StudentAttendanceDialog.vue?vue&type=script&lang=js"

import "./StudentAttendanceDialog.vue?vue&type=style&index=0&id=0f81bb57&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f81bb57"]])

export default __exports__